<template>
	<InfoText v-if="tnc_display" textClass="responsible-gaming" :cacheKey="`responsible_gaming_${locale}`" :textUrl="`{m}backend/{env}/${locale}/responsible_gaming.html.gz`" @textHandler="textHandler" />
</template>

<script setup>
const { locale } = useI18n()

definePageMeta({
	layout: "info",
});

const tnc_display = ref(true)
const textHandler = (e) => {
	tnc_display.value = false;
}

</script>